export enum localeName {
    EN = 'en',
    SV = 'sv',
}
